import { useRef, useState } from "react";
import { useDispatch } from 'react-redux';
import { cancelBatch} from '../../../actions/hpmAction';
import { getCurrentWarehouse, getUserPreference } from "../../../utilities/common";
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { useTranslation } from 'react-i18next';
import { showAlertSnackbar } from "../../../reducers/uiSlice";

const useStyles = makeStyles((theme) => ({
    total: {
        display: 'flex',
        flexDirection: 'column'
    },
    root: {
        display: 'flex',
        width: '100%',
        alignItems: 'center'
    },
    container: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        marginTop: 20
    },
    textFieldStyle: {
        width: '60%',
        marginRight: 10
    },
    buttonStyle: {
        width: '30%'
    }
}));

function CancelBatch() {
    const classes = useStyles();
    const {t} = useTranslation('holdingPackagesManagement');
    const dispatch = useDispatch();
    let warehouse = getCurrentWarehouse()['name'];

    const [blockBatch, setBlockBatch] = useState('');
    const [disable, setDisable] = useState(false);

    const handleBlockBatchInput = (event) => {
        setBlockBatch(event.target.value);
    };

    return (
        <div className={classes.total}>
            <div className={classes.root}>
                <TextField
                    placeholder={t('input_block_batch')}
                    onChange={handleBlockBatchInput}
                    rows={10}
                    variant="outlined"
                    className={classes.textFieldStyle}
                />
                <Button 
                    variant="contained" 
                    color="#616161" 
                    onClick={handleCancelBatch}
                    className={classes.buttonStyle}
                    disabled={disable}
                >
                    {t('cancel_batch')}
                </Button>
            </div>
        </div>
    );

    function handleCancelBatch() {
        setDisable(true);
        dispatch(cancelBatch(blockBatch, warehouse))
        .then((res) => {
            setDisable(false);
            dispatch(showAlertSnackbar({message: t('cancel_success_message'), type: 'success'}))
        })
        .catch((err) => {
            setDisable(false);
            dispatch(showAlertSnackbar({message: t('cancel_fail_message'), type: 'error'}))
        })
    }
}

export default CancelBatch;